import { useRecoilValue, useSetRecoilState } from "recoil";
import { selectedTicketIdState, supportRequestModalState, supportTicketsState } from "../../views/portal/ManageTickets/atoms";
import Card from "../custom/Card";
import styled from "styled-components";
import { IUser, SupportTicket } from "../../globals/interfaces";
import { useAppContext } from "../../context";
import { compareEmails, formatDatetime } from "../../utils";
import useSupportTickets from "../../views/portal/ManageTickets/useSupportTickets";
import apiClient from "../../apiClient";
import { useEffect } from "react";
import useUser from "../../customHooks/useUser";
import { getUnreadMessagesCount } from "../../views/portal/ManageTickets";
import UnreadMessagesCount from "../../views/portal/ManageTickets/UnreadMessagesCount";

export default function ProfileTickets() {

    const { user } = useUser();
    const { supportTickets, updateData } = useSupportTickets(
        user.s_email,
        `/support-ticket?createdBy=${user.s_email}&notAcknowledged=${true}`, 
        true
    );
    const setSelectedTicketId = useSetRecoilState(selectedTicketIdState);
    const setTicketModal = useSetRecoilState(supportRequestModalState);

    useEffect(() => {
        const getUserTickets = async () => {
            try {
                const res = await apiClient.get(`/support-ticket?createdBy=${user.s_email}&notAcknowledged=${true}`);
                updateData(res.data);
            } catch (err) {
                alert(err);
            }
        }
        getUserTickets();
    }, []);

    const handleSelectTicket = (ticketId: number) => {
        setSelectedTicketId(ticketId);
        setTicketModal(true);
    }

    return (
        <Card className={'mt-2'}>
            {
                supportTickets.map((item, i) => (
                    <Ticket 
                        item={item} 
                        user={user} 
                        handleSelectTicket={handleSelectTicket} 
                        key={i} 
                    />
                ))
            }
        </Card>
    );
}

const Ticket = ({
    item,
    user,
    handleSelectTicket
}: {
    item: SupportTicket;
    user: IUser;
    handleSelectTicket: (ticketId: number) => void;
}) => {

    const unreadMessagesCount = getUnreadMessagesCount(item, user);

    return (
        <Card
            backgroundColor="#E6FFCE" className={'hover-pointer my-2'}
            onClick={() => handleSelectTicket(item.id)}
        >
            <p>{item.title}</p>
            <FlexContainer>
                <p>{formatDatetime(item.createdAt)}</p>
                <UnreadMessagesCount unreadMessagesCount={unreadMessagesCount} />
            </FlexContainer>
        </Card>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;